// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"8ba7b8a7","605":"623179c1","809":"62452d41","981":"8a166704"}[chunkId] + ".chunk.js";
};